export default "https://static-tg.3jyx.cn/mallfe/_next/static/images/500w-2b0e57e3d57b831ace6a1158d2020053.webp";